import { render, staticRenderFns } from "./create-topic.vue?vue&type=template&id=10c81933&"
import script from "./create-topic.vue?vue&type=script&lang=ts&"
export * from "./create-topic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-topic.vue"
export default component.exports